import { assign } from 'xstate';
import type { UiContext } from './context';

type PersonaDetailsEvent = { type: 'PERSONA_DETAILS'; personaName: string };
type ConceptDetailsEvent = { type: 'CONCEPT_DETAILS'; conceptName: string };
type ConceptActivateEvent = { type: 'CONCEPT_ACTIVATE'; conceptName: string };
export type UiEvent =
	| { type: 'CLOSE' }
	| { type: 'NEXT' }
	| { type: 'DETAILS' }
	| { type: 'ACTIVATE' }
	| PersonaDetailsEvent
	| ConceptDetailsEvent
	| ConceptActivateEvent
	| { type: 'CONCEPTS' }
	| { type: 'FINISH_PLAYTHROUGH'; wantFeedback: boolean }
	| { type: 'NEW' }
	| { type: 'FINISH' }
	| { type: 'SKIP_TUTORIAL' };

export const assignPersonaName = assign<UiContext, PersonaDetailsEvent>(
	(ctx, event) => ({
		...ctx,
		personaName: event.personaName
	})
);

export const assignConceptNameByDetails = assign<
	UiContext,
	ConceptDetailsEvent
>((ctx, event) => ({
	...ctx,
	conceptName: event.conceptName
}));

export const assignConceptNameByActivation = assign<
	UiContext,
	ConceptActivateEvent
>((ctx, event) => ({
	...ctx,
	conceptName: event.conceptName
}));
